import { create } from 'zustand';

export const cacheStore = create((set) => ({
    cacheData: [],
    setCacheData: (data) => set({ cacheData: data }),
}));
